import config from "./config.json";

export type Color = keyof typeof config.colors;
export { config };
export const colors = config.colors;
